"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.reduce.js");

var _reactDropzone = require("react-dropzone");

var _utility = require("../utility");

var _DragAndDrop = require("./DragAndDrop.Styled");

var _toast = _interopRequireWildcard(require("../toast"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const DragAndDrop = _ref => {
  let {
    title,
    hint,
    onFileCallback,
    files,
    maxFileSizeInBytes = 0,
    allowedFileExtensions,
    maxFileSizeExceededToast,
    invalidFileExtensionToast,
    multiple = true
  } = _ref;

  const getExtension = filename => filename.split('.').pop();

  const validateFile = file => {
    if (file.size > maxFileSizeInBytes) {
      (0, _toast.default)(_toast.TYPE.ERROR, maxFileSizeExceededToast);
      return false;
    }

    if (Array.isArray(allowedFileExtensions) && !allowedFileExtensions.includes(getExtension(file.name).toLowerCase())) {
      (0, _toast.default)(_toast.TYPE.ERROR, invalidFileExtensionToast);
      return false;
    }

    return true;
  };

  const onDrop = files => {
    const isValid = files.reduce((acc, file) => {
      if (!acc) return false;
      return validateFile(file);
    }, true);
    onFileCallback(isValid ? files : []);
  };

  const {
    getRootProps,
    getInputProps
  } = (0, _reactDropzone.useDropzone)({
    onDrop,
    multiple
  }); // isDragActive is also a property

  if (!title || typeof onFileCallback !== 'function' || !maxFileSizeInBytes || !maxFileSizeExceededToast) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_DragAndDrop.StyledDragAndDrop, getRootProps(), /*#__PURE__*/_react.default.createElement("input", getInputProps()), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DragAndDrop.Title, null, title), /*#__PURE__*/_react.default.createElement(_DragAndDrop.Hint, null, hint), Array.isArray(files) && files.length > 0 && /*#__PURE__*/_react.default.createElement(_DragAndDrop.FileList, null, files.map(file => /*#__PURE__*/_react.default.createElement(_DragAndDrop.FileName, {
    key: (0, _utility.getUUID)()
  }, file.name)))));
};

var _default = DragAndDrop;
exports.default = _default;